export const parseTime = (time) => {
    if (!time) {
        return '-';
    }
    return new Date(time).format('yyyy/MM/dd hh:mm:ss')
}

export const parseTime1 = (time) => {
    if (!time) {
        return '-';
    }
    if (time < 0) {
        return '-'
    }
    return new Date(time).format('yyyy-MM-dd hh:mm')
}

export const parsePropertyType = (code) => {
    switch (code) {
        case 0:
            return 'int';
        case 1:
            return 'decimal';
        case 2:
            return 'string';
        case 3:
            return 'jsonObject';
        case 4:
            return 'dateTime';
    }
}

export const parseAccess = (code) => {
    switch (code) {
        case 0:
            return '无'
        case 1:
            return '可读'
        case 2:
            return '可写'
        case 3:
            return '可读，可写'
    }
}


export const parseProtoText = (v) => {
    const data = ['MQTT', 'LwM2M/CoAP', 'HTTP/HTTP2', 'Modbus'];
    return data[v]
}

export const parseDataEncode = (code) => {
    switch (code) {
        case 0:
            return 'JSON';
        case 1:
            return '二进制码流';
    }
}

export const parseDeviceStatusText = (code) => {
    const data = ['未激活', '离线', '在线', '冻结'];
    return data[code]
}

export const parseDeviceStatusBackground = (code) => {
    const data = ['#FDF4EA', '#F2F2F3', '#E1F3D8', '#FEEDEE'];
    return data[code]
}

export const parseDeviceStatusColor = (code) => {
    const data = ['#E6A23C', '#909399', '#67C23A', '#F56C6C'];
    return data[code]
}

export const parseDeviceLevel = (code) => {
    if (code === 0) {
        return '直连设备'
    } else {
        return '非直连设备'
    }
}

export const parseCommandStatus = code => {
    const data = ['等待', '发送成功', '失败', '超时'];
    return data[code];
}